<template>
  <!-- R3数据报表：账户报表 / 素材报表 -->
  <div class="paddbox r3-page">
    <!-- 顶部标题栏 -->
    <div class="page-head">
      <div class="head-left">
        <div class="head-title">数据报表</div>
        <div class="head-sub">全域投放效果视图，支持账户 / 项目 /（按天 / 按月）</div>
      </div>
      <div class="head-right">
        <el-date-picker v-if="dateType === 'day'" v-model="date" type="daterange" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :shortcuts="shortcuts" format="YYYY-MM-DD"
          value-format="YYYY-MM-DD" @change="dateChangeFun" />
        <el-date-picker v-else v-model="monthRange" type="monthrange" unlink-panels range-separator="至"
          start-placeholder="开始月份" end-placeholder="结束月份" format="YYYY-MM" value-format="YYYY-MM"
          @change="monthChangeFun" />
      </div>
    </div>

    <!-- 一级：全域报表 / 升级版报表（升级版接口暂未提供，先占位禁用） -->
    <div class="level1-row">
      <div v-for="t in level1Tabs" :key="t.value" class="level1-card"
        :class="{ active: reportTab === t.value, disabled: t.disabled }" @click="switchLevel1Fun(t.value)">
        <div class="l1-icon" :class="t.value">{{ t.icon }}</div>
        <div class="l1-text">
          <div class="l1-name">{{ t.label }}<span v-if="t.disabled" class="l1-badge">敬请期待</span></div>
          <div class="l1-desc">{{ t.desc }}</div>
        </div>
        <div class="l1-check" v-if="reportTab === t.value && !t.disabled">● 已选</div>
      </div>
    </div>

    <!-- 升级版占位提示条（不遮挡下方内容，导航始终可见） -->
    <el-alert v-if="showShengjiTip" title="升级版报表接口暂未提供，当前仅展示全域报表（17 / 18）" type="warning" show-icon closable
      @close="showShengjiTip = false" style="margin-bottom: 0" />

    <!-- 筛选区（复用 indexData.vue：投放人 / 账户ID / 部门） -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-row">
        <div class="filter-item">
          <span class="filter-label">统计口径</span>
          <el-radio-group v-model="dateType" @change="dateTypeChangeFun">
            <el-radio-button label="day">按天</el-radio-button>
            <!-- <el-radio-button label="month">按月汇总</el-radio-button> -->
          </el-radio-group>
        </div>
        <div class="filter-item">
          <span class="filter-label">投放人</span>
          <el-select collapse-tags clearable filterable v-model="userName" multiple placeholder="投放人"
            style="width: 180px">
            <el-option v-for="item in getRequestLists.userName" :key="item.id" :label="item.value" :value="item.id" />
          </el-select>
        </div>

        <div class="filter-item">
          <span class="filter-label">账户ID</span>
          <el-input type="textarea" :rows="1" placeholder="批量粘贴账户ID，每行一个" v-model="textstring"
            @change="accountInputChangeFun" style="width: 180px" />
        </div>

        <div class="filter-item" v-if="reportSub === 'material'">
          <span class="filter-label">素材ID</span>
          <el-input type="textarea" :rows="1" placeholder="批量粘贴素材ID，每行一个" v-model="materialIdtextstring"
            @change="materialIdInputChangeFun" style="width: 180px" />
        </div>
        <div class="filter-item" v-if="reportSub === 'material'">
          <span class="filter-label">素材名称</span>
          <el-input type="textarea" :rows="1" placeholder="批量粘贴素材名称，每行一个" v-model="materialNametextstring"
            @change="materialNameInputChangeFun" style="width: 180px" />
        </div>

        <div class="filter-item">
          <span class="filter-label">部门</span>
          <el-cascader v-model="groupName" :options="getRequestLists.groupName"
            :props="{ checkStrictly: true, value: 'id', label: 'label' }" clearable placeholder="部门"
            style="width: 180px" />
        </div>

        <div class="filter-item">
          <span class="filter-label">剧种</span>
          <el-select v-model="quanyuType" placeholder="全部" style="width: 140px" clearable>
            <!-- <el-option label="全部" :value="null" /> -->
            <el-option label="全域真人剧" :value="17" />
            <el-option label="全域漫剧" :value="18" />
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-label">排序数据</span>
          <el-select v-model="orderField" filterable style="width: 140px" clearable>
            <el-option v-for="item in orderFieldData" :key="item.value" :label="item.label" :value="item.value">
            </el-option>

          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-label">排序方式</span>
          <el-select v-model="orderDir" filterable style="width: 140px" clearable>
            <el-option v-for="item in orderDirData" :key="item.value" :label="item.label" :value="item.value">
            </el-option>

          </el-select>
        </div>


        <!-- <div class="filter-item">
          <span class="filter-label">关键字（本页过滤）</span>
          <el-input v-model="accountName" clearable placeholder="账户/项目/素材ID模糊搜" style="width: 180px"
            @keyup.enter="keywordEnterFun" />
        </div> -->

        <div class="filter-btns">
          <el-button type="primary" @click="searchFun">搜索</el-button>
          <!-- <el-button @click="resetFun">重置</el-button> -->
          <!-- <el-button type="success" plain @click="exportFun">导出</el-button> -->
          <!-- <el-button v-if="reportSub === 'material'" plain @click="syncFun">补数</el-button> -->
        </div>
      </div>
      <div class="filter-hint" v-if="accountId.length > 0">
        已解析账户ID <b>{{ accountId.length }}</b> 个：{{ accountId.slice(0, 5).join('、') }}{{ accountId.length > 5 ? ' …' : ''
        }}
        <span class="clear-link" @click="clearAccountIdFun">清空</span>
      </div>
      <div class="filter-hint" v-if="materialIdList.length > 0 && reportSub === 'material'">
        已解析素材ID <b>{{ materialIdList.length }}</b> 个：{{ materialIdList.slice(0, 5).join('、') }}{{ materialIdList.length
          > 5 ? ' …' : ''
        }}
        <span class="clear-link" @click="clearmaterialIdFun">清空</span>
      </div>
      <div class="filter-hint" v-if="materialNameList.length > 0 && reportSub === 'material'">
        已解析素材名称 <b>{{ materialNameList.length }}</b> 个：{{ materialNameList.slice(0, 5).join('、') }}{{
          materialNameList.length
            > 5 ? ' …' : ''
        }}
        <span class="clear-link" @click="clearmateriaNameFun">清空</span>
      </div>
      <div class="filter-hint warn" v-if="dateType === 'day' && daySpan > 31">
        当前日期跨度 {{ daySpan }} 天，接口要求按天最多相差 31 天，请缩短区间或切换到「按月汇总」。
      </div>
    </el-card>

    <!-- KPI 汇总（本页合计） -->
    <div class="kpi-row" v-if="reportSub === 'account'">
      <div class="kpi-card cost">
        <div class="kpi-label">消耗</div>
        <div class="kpi-value"> {{ kpi.cost }}</div>
        <div class="kpi-foot">共 {{ total }} 条 · 本页 {{ tableData.length }} 条</div>
      </div>
      <div class="kpi-card amount">
        <div class="kpi-label">GMV</div>
        <div class="kpi-value"> {{ kpi.amount }}</div>
        <div class="kpi-foot"> </div>
      </div>
      <div class="kpi-card amount">
        <div class="kpi-label">当日GMV</div>
        <div class="kpi-value"> {{ kpi.gmv0day }}</div>
        <div class="kpi-foot"> </div>
      </div>
      <div class="kpi-card amount">
        <div class="kpi-label">24小时GMV</div>
        <div class="kpi-value"> {{ kpi.gmv24h }}</div>
        <div class="kpi-foot"></div>
      </div>
      <div class="kpi-card profit">
        <div class="kpi-label">3日 GMV</div>
        <div class="kpi-value"> {{ kpi.gmv3days }}</div>
        <div class="kpi-foot"></div>
      </div>
      <div class="kpi-card profit">
        <div class="kpi-label">7日 GMV</div>
        <div class="kpi-value"> {{ kpi.gmv7days }}</div>
        <div class="kpi-foot"></div>
      </div>

      <div class="kpi-card fans">
        <div class="kpi-label">粉丝量</div>
        <div class="kpi-value">{{ kpi.fans }}</div>
        <div class="kpi-foot"></div>
      </div>
      <div class="kpi-card fans">
        <div class="kpi-label">展示</div>
        <div class="kpi-value">{{ kpi.show }}</div>
        <div class="kpi-foot"></div>
      </div>
      <div class="kpi-card fans">
        <div class="kpi-label">点击</div>
        <div class="kpi-value">{{ kpi.click }}</div>
        <div class="kpi-foot"></div>
      </div>
      <!-- <div class="kpi-card recovery">
        <div class="kpi-label">GMV / 消耗（本页）</div>
        <div class="kpi-value">{{ kpi.recovery }}%</div>
        <div class="kpi-foot">
          <el-progress :percentage="recoveryBar" :stroke-width="8" :show-text="false" />
        </div>
      </div> -->
    </div>

    <div class="kpi-row" v-else>
      <div class="kpi-card cost">
        <div class="kpi-label">展示</div>
        <div class="kpi-value">{{ kpi.show }}</div>
        <div class="kpi-foot">共 {{ total }} 条 · 本页 {{ tableData.length }} 条</div>
      </div>
      <div class="kpi-card amount">
        <div class="kpi-label">点击</div>
        <div class="kpi-value">{{ kpi.click }}</div>
        <div class="kpi-foot">平均CTR {{ kpi.ctr }}%</div>
      </div>
      <div class="kpi-card profit">
        <div class="kpi-label">GMV</div>
        <div class="kpi-value">¥ {{ kpi.amount }}</div>
        <div class="kpi-foot">24h ¥ {{ kpi.gmv24h }} · 当日 ¥ {{ kpi.gmv0day }}</div>
      </div>
      <div class="kpi-card fans">
        <div class="kpi-label">变现金额</div>
        <div class="kpi-value">¥ {{ kpi.microAmount }}</div>
        <div class="kpi-foot">付费金额 ¥ {{ kpi.payAmount }}</div>
      </div>
      <div class="kpi-card recovery">
        <div class="kpi-label">3日 GMV</div>
        <div class="kpi-value">¥ {{ kpi.gmv3days }}</div>
        <div class="kpi-foot">共 {{ total }} 条素材记录</div>
      </div>
    </div>

    <!-- 二级导航 -->
    <el-card class="nav-card" shadow="never">
      <div class="nav-row">
        <el-radio-group v-model="reportSub" size="large" @change="switchSubFun">
          <el-radio-button label="account">账户报表</el-radio-button>
          <el-radio-button label="material">素材报表</el-radio-button>
        </el-radio-group>
        <div style="margin-left: auto">
          <el-button type="success" plain :loading="exportLoading" @click="exportFun">导出</el-button>
        </div>
        <!-- <div class="breadcrumb-mini">
          数据报表 / {{ reportTab === 'quanyu' ? '全域报表' : '升级版报表' }} /
          {{ reportSub === 'account' ? '账户报表' : '素材报表' }}
          <span> / {{ dateType === 'day' ? '按天' : '按月汇总' }}</span>
        </div> -->
      </div>
    </el-card>

    <!-- 表格区 -->
    <el-card class="table-card" shadow="never" v-loading="loading">
      <!-- 账户报表（账户汇总） -->
      <div v-if="reportSub === 'account'">
        <div class="table-title">
          <span>账户报表 <span class="count">（共 {{ total }} 条）</span></span>
          <!-- <span class="title-tip">每天 × 账户一行（按月时一账户一行），projectId 为空</span> -->
        </div>
        <div class="table-scroll"><el-table :data="tableData" border stripe style="width: 100%" empty-text="暂无数据">
            <el-table-column label="日期" prop="statDate" width="100">
              <template #default="scope">{{ scope.row.statDate || monthLabel }}</template>
            </el-table-column>
            <el-table-column label="账户ID" prop="advertiserId" width="160" sortable />
            <el-table-column label="账户名称" prop="accountName" width="160" sortable />
            <el-table-column label="投放人" prop="userName" width="100" />
            <el-table-column label="全域消耗" prop="statCost" width="110" sortable align="right">
              <template #default="scope">{{ formatMoney(scope.row.statCost) }}</template>
            </el-table-column>
            <el-table-column label="24h GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv24h) }}</template>
            </el-table-column>
            <el-table-column label="展示" prop="showCnt" width="100" sortable align="right">
              <template #default="scope">{{ formatNum(scope.row.showCnt) }}</template>
            </el-table-column>
            <el-table-column label="点击" prop="clickCnt" width="90" sortable align="right">
              <template #default="scope">{{ formatNum(scope.row.clickCnt) }}</template>
            </el-table-column>
            <el-table-column label="CTR" width="90" align="right">
              <template #default="scope">{{ formatCtr(scope.row.ctr) }}</template>
            </el-table-column>
            <el-table-column label="GMV" prop="gmv" width="110" sortable align="right">
              <template #default="scope">{{ formatMoney(scope.row.gmv) }}</template>
            </el-table-column>
            <el-table-column label="当日GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv0day) }}</template>
            </el-table-column>
            <el-table-column label="3日GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv3days) }}</template>
            </el-table-column>
            <el-table-column label="7日GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv7days) }}</template>
            </el-table-column>
            <!-- <el-table-column label="成本" width="100" align="right">
              <template #default="scope">{{ formatMoney(scope.row.statTotalCost) }}</template>
            </el-table-column> -->
            <el-table-column label="粉丝" prop="dyFollow" width="80" sortable align="right">
              <template #default="scope">{{ formatNum(scope.row.dyFollow) }}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" link @click="gotoProjectFun(scope.row)">查看项目</el-button>
              </template>
            </el-table-column>
          </el-table></div>
      </div>

      <!-- 项目报表弹窗（账户行「查看项目」进入） -->
      <el-dialog v-model="projectView" title="项目报表" width="85%" top="5vh">
        <div class="table-title">
          <span>项目报表
            <span class="count" v-if="focusAccountId">（账户 {{ focusAccountId }}，共 {{ projectTotal }} 条）</span>
            <span class="count" v-else>（共 {{ projectTotal }} 条）</span>
          </span>
        </div>
        <div class="table-scroll" v-loading="projectLoading"><el-table :data="projectTable" border stripe
            style="width: 100%" empty-text="暂无数据">
            <el-table-column label="日期" prop="statDate" width="110">
              <template #default="scope">{{ scope.row.statDate || monthLabel }}</template>
            </el-table-column>
            <el-table-column label="账户ID" prop="advertiserId" width="160" sortable />
            <el-table-column label="账户名称" prop="accountName" width="160" sortable />
            <el-table-column label="项目名称" prop="projectName" width="160" sortable />
            <el-table-column label="项目ID" prop="projectId" sortable />
            <el-table-column label="投放人" prop="userName" width="100" />
            <el-table-column label="全域消耗" width="110" sortable align="right">
              <template #default="scope">{{ formatMoney(scope.row.statCost) }}</template>
            </el-table-column>
            <el-table-column label="展示" width="100" sortable align="right">
              <template #default="scope">{{ formatNum(scope.row.showCnt) }}</template>
            </el-table-column>
            <el-table-column label="点击" width="90" sortable align="right">
              <template #default="scope">{{ formatNum(scope.row.clickCnt) }}</template>
            </el-table-column>
            <el-table-column label="CTR" width="90" align="right">
              <template #default="scope">{{ formatCtr(scope.row.ctr) }}</template>
            </el-table-column>
            <el-table-column label="GMV" width="110" sortable align="right">
              <template #default="scope">{{ formatMoney(scope.row.gmv) }}</template>
            </el-table-column>
            <el-table-column label="24h GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv24h) }}</template>
            </el-table-column>
            <el-table-column label="当日GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv0day) }}</template>
            </el-table-column>
            <el-table-column label="3日GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv3days) }}</template>
            </el-table-column>
            <el-table-column label="7日GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv7days) }}</template>
            </el-table-column>
            <!-- <el-table-column label="成本" width="100" align="right">
              <template #default="scope">{{ formatMoney(scope.row.statTotalCost) }}</template>
            </el-table-column> -->
            <el-table-column label="粉丝" width="80" sortable align="right">
              <template #default="scope">{{ formatNum(scope.row.dyFollow) }}</template>
            </el-table-column>
          </el-table></div>
        <div class="pagination">
          <pagination @handleSizeChange="handleProjectSizeChange" @handleCurrentChange="handleProjectCurrentChange"
            :total="projectTotal" :pagesize="projectPagesize" :pagesizes="pagesizes"
            :currentPage="projectCurrentPage" />
        </div>
      </el-dialog>

      <!-- 素材报表 -->
      <div v-if="reportSub === 'material'">
        <div class="table-title">
          <span>素材报表 <span class="count">（共 {{ total }} 条）</span></span>
          <span class="title-tip">不传账户id按素材总量聚合；传账户id按 账户 × 素材明细</span>
        </div>
        <div class="table-scroll"><el-table :data="viewData" border stripe style="width: 100%" empty-text="暂无数据">
            <el-table-column label="日期" prop="statDate" width="110">
              <template #default="scope">{{ scope.row.statDate || monthLabel }}</template>
            </el-table-column>
            <el-table-column label="素材ID" prop="materialId" width="180" sortable />
            <el-table-column label="素材名称" prop="filename" width="180" sortable />
            <!-- <el-table-column label="素材类型" prop="imageMode" width="90" align="center">
              <template #default="scope">{{ scope.row.imageMode ?? '-' }}</template>
            </el-table-column> -->
            <el-table-column label="账户ID" prop="advertiserId" width="160" sortable v-if="accountId.length > 0">
              <template #default="scope">{{ scope.row.advertiserId ?? '-' }}</template>
            </el-table-column>
            <el-table-column label="投放人" prop="userName" width="100" v-if="accountId.length > 0">
              <template #default="scope">{{ scope.row.userName ?? '-' }}</template>
            </el-table-column>
            <el-table-column label="展示" width="100" sortable align="right">
              <template #default="scope">{{ formatNum(scope.row.showCnt) }}</template>
            </el-table-column>
            <el-table-column label="点击" width="90" sortable align="right">
              <template #default="scope">{{ formatNum(scope.row.clickCnt) }}</template>
            </el-table-column>
            <el-table-column label="CTR" width="90" align="right">
              <template #default="scope">{{ formatCtr(scope.row.ctr) }}</template>
            </el-table-column>
            <el-table-column label="GMV" width="110" sortable align="right">
              <template #default="scope">{{ formatMoney(scope.row.gmv) }}</template>
            </el-table-column>
            <el-table-column label="24h GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv24h) }}</template>
            </el-table-column>
            <el-table-column label="当日GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv0day) }}</template>
            </el-table-column>
            <el-table-column label="3日GMV" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.billingGmv3days) }}</template>
            </el-table-column>
            <el-table-column label="变现金额" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.microGameAmount) }}</template>
            </el-table-column>
            <el-table-column label="付费金额" width="110" align="right">
              <template #default="scope">{{ formatMoney(scope.row.payAmountFen) }}</template>
            </el-table-column>
          </el-table></div>
      </div>

      <div class="pagination">
        <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
          :pagesize="pagesize" :pagesizes="pagesizes" :currentPage="currentPage" />
      </div>
    </el-card>
  </div>
</template>

<script>
import pagination from '@/components/pagination.vue' // 导入分页组件
import {
  projectReportPageAccountByDay,
  projectReportPageAccountByMonth,
  projectReportPageProjectByDay,
  projectReportPageProjectByMonth,
  projectReporttotalAccountByDay,
  materialReportPageByDay,
  materialReportPageByMonth,
  materialReporttotalByMonth,
  materialReportSync,
  materialReporttotalByDay,
  projectReportsync,
  projectReporttotalAccountByMonth,
  projectReporttotalProjectByMonth,
} from '@/request/new/ylyBatch'
import { getRequestList } from '@/request/new/nueDataSystem'
import { baseURL } from '@/request/config'
import { ElMessage } from 'element-plus'
import { reactive, toRefs, computed } from 'vue'
export default {
  name: 'shujufenxi',
  components: { pagination },
  setup() {
    // 当天日期 YYYY-MM-DD
    const todayStr = () => {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    }
    // 当前月份 YYYY-MM（按月统计口径默认用）
    const todayMonthStr = () => {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      return `${y}-${m}`
    }
    // 月初 YYYY-MM-DD：'2026-09' -> '2026-09-01'
    const monthStartStr = (ym) => {
      if (!ym) return ''
      const [y, m] = String(ym).split('-')
      return `${y}-${String(m).padStart(2, '0')}-01`
    }
    // 月末 YYYY-MM-DD：'2026-09' -> '2026-09-30'（按实际天数，闰年2月29天也对）
    const monthEndStr = (ym) => {
      if (!ym) return ''
      const [y, m] = String(ym).split('-').map(Number)
      const last = new Date(y, m, 0).getDate()
      return `${y}-${String(m).padStart(2, '0')}-${String(last).padStart(2, '0')}`
    }
    // 日期跨度（天，含头含尾）
    const diffDays = (a, b) => {
      if (!a || !b) return 0
      const t1 = new Date(a).getTime()
      const t2 = new Date(b).getTime()
      if (Number.isNaN(t1) || Number.isNaN(t2)) return 0
      return Math.round((t2 - t1) / (1000 * 60 * 60 * 24)) + 1
    }
    // 金额保留2位，null 按 0 处理
    const formatMoney = (v) => {
      if (v === null || v === undefined || v === '') return '0.00'
      const n = Number(v)
      if (Number.isNaN(n)) return '0.00'
      return n.toFixed(2)
    }
    // 数量展示，整数不带小数，null 按 0 处理
    const formatNum = (v) => {
      if (v === null || v === undefined || v === '') return '0'
      const n = Number(v)
      if (Number.isNaN(n)) return '0'
      return Number.isInteger(n) ? String(n) : n.toFixed(2)
    }
    // ctr 是小数（如 0.02），显示百分比要 ×100 保留2位
    const formatCtr = (v) => {
      if (v === null || v === undefined || v === '') return '0.00%'
      const n = Number(v)
      if (Number.isNaN(n)) return '0.00%'
      return `${(n * 100).toFixed(2)}%`
    }

    const state = reactive({
      // 一级导航：quanyu 全域 / shengji 升级版（升级版接口暂未提供，先占位禁用）
      reportTab: 'quanyu',
      // 升级版提示条开关
      showShengjiTip: false,
      // 一级导航卡片
      level1Tabs: [
        { label: '全域报表', value: 'quanyu', icon: '全', desc: '全域投放 · 真人剧 / 漫剧，不选查全部' },
        { label: '升级版报表', value: 'shengji', icon: '升', desc: '升级版接口暂未提供，敬请期待', disabled: true },
      ],
      // 二级导航：account 账户报表 / material 素材报表
      reportSub: 'account',
      // 下钻中的账户ID（查看项目弹窗赋值）
      focusAccountId: '',
      // 日期范围
      date: [todayStr(), todayStr()],
      // 月份范围（按月时用，[开始月份, 结束月份]，YYYY-MM，默认当前月）
      monthRange: [todayMonthStr(), todayMonthStr()],
      // 统计口径：day 按天 / month 按月汇总
      dateType: 'day',
      // 剧种：null 全部(17+18) / 17 全域真人剧 / 18 全域漫剧
      quanyuType: 18,
      // 日期快捷选项
      shortcuts: [
        { text: '今天', value: () => [todayStr(), todayStr()] },
        {
          text: '近7天',
          value: () => {
            const e = new Date()
            const s = new Date()
            s.setTime(s.getTime() - 3600 * 1000 * 24 * 6)
            const f = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
            return [f(s), f(e)]
          },
        },
        {
          text: '近31天',
          value: () => {
            const e = new Date()
            const s = new Date()
            s.setTime(s.getTime() - 3600 * 1000 * 24 * 30)
            const f = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
            return [f(s), f(e)]
          },
        },
      ],
      //排序数据
      orderFieldData: [
        { label: '展示', value: 'showCnt' },
        { label: '点击', value: 'clickCnt' },
        { label: 'GMV', value: 'gmv' },
        { label: '24HGMV', value: 'billingGmv24h' },
        { label: '当日GMV', value: 'billingGmv0day' },
        { label: '3日GMV', value: 'billingGmv3days' },
        { label: '变现金额', value: 'microGameAmount' },
        { label: '付费金额', value: 'payAmountFen' },
        { label: 'CTR', value: 'ctr' }
      ],
      //排序方式
      orderDirData: [
        { label: '倒序', value: 'desc' },
        { label: '正序', value: 'asc' }
      ],
      orderField: 'gmv',
      orderDir: 'desc',
      // 获取数据员角色，不展示相关数据
      shujuyuan: localStorage.getItem('shujuyuan'),
      // 投放人（多选）
      userName: [],
      // 账户ID输入框原文（批量粘贴，每行一个）
      textstring: '',
      // 素材ID输入框原文（批量粘贴，每行一个）
      materialIdtextstring: '',
      // 素材名称输入框原文（批量粘贴，每行一个）
      materialNametextstring: '',
      // 解析后的账户ID数组
      accountId: [],
      // 解析后的素材ID数组
      materialIdList: [],
      // 解析后的素材名称数组
      materialNameList: [],
      // 部门（级联）
      groupName: [],
      // 关键字输入框
      accountName: '',
      // 生效中的关键字（搜索时同步，本页过滤用）
      keyword: '',
      // 筛选下拉数据
      getRequestLists: { userName: [], groupName: [] },
      // 项目弹窗开关
      projectView: false,
      // 项目弹窗表格数据
      projectTable: [],
      // 项目弹窗加载中
      projectLoading: false,
      // 项目弹窗条数
      projectPagesize: 50,
      // 项目弹窗当前页数
      projectCurrentPage: 1,
      // 项目弹窗总数
      projectTotal: 0,
      // 项目弹窗页数 发生改变
      handleProjectCurrentChange: (e) => {
        state.projectCurrentPage = e
        projectReportPageProjectFun()
      },
      // 项目弹窗个数 发生改变
      handleProjectSizeChange: (e) => {
        state.projectPagesize = e
        state.projectCurrentPage = 1
        projectReportPageProjectFun()
      },
      // KPI汇总（本页合计）
      kpi: {
        cost: '0.00', amount: '0.00', gmv24h: '0.00', gmv0day: '0.00', gmv3days: '0.00',
        gmv7days: '0.00', totalCost: '0.00', fans: '0', show: '0', click: '0',
        ctr: '0.00', recovery: '0.00', microAmount: '0.00', payAmount: '0.00',
      },
      // 表格数据
      tableData: [],
      // 导出按钮 loading（等后端导出接口接入后使用）
      exportLoading: false,
      // 加载中
      loading: false,
      // 可选条数
      pagesizes: [20, 50, 100, 200, 500],
      // 条数
      pagesize: 50,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 0,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        reportListFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        state.currentPage = 1
        reportListFun()
      },
    })

    // 日期跨度（天）
    const daySpan = computed(() => diffDays(state.date?.[0], state.date?.[1]))
    // 请求用时间：按天取 date；按月把月份区间展开成首日/末日，接口仍是 YYYY-MM-DD（选择器显示保持 YYYY-MM）
    const timeRange = computed(() => {
      if (state.dateType === 'month') {
        const s = state.monthRange?.[0] || todayMonthStr()
        const e = state.monthRange?.[1] || s
        return { start: monthStartStr(s), end: monthEndStr(e) }
      }
      return { start: state.date?.[0], end: state.date?.[1] }
    })
    // 按月时日期列显示区间（取月份范围）
    const monthLabel = computed(() => {
      if (!state.monthRange || !state.monthRange[0]) return '月汇总'
      return `${state.monthRange[0]} ~ ${state.monthRange[1] || state.monthRange[0]}`
    })
    // 回本进度条（超过100按100显示）
    const recoveryBar = computed(() => {
      const v = Number(state.kpi.recovery)
      if (Number.isNaN(v)) return 0
      return v > 100 ? 100 : v < 0 ? 0 : v
    })
    // 关键字只做本页过滤（后端不支持模糊搜）
    const viewData = computed(() => {
      const q = (state.keyword || '').trim()
      if (!q) return state.tableData
      return state.tableData.filter((r) =>
        `${r.advertiserId ?? ''}${r.projectId ?? ''}${r.materialId ?? ''}${r.userName ?? ''}`.includes(q),
      )
    })

    // 取部门最后一级（与 indexData 一致）
    const lastGroupFun = () => {
      if (!state.groupName || state.groupName.length === 0) return null
      const g = state.groupName
      if (Array.isArray(g) && g.length > 0 && Array.isArray(g[g.length - 1])) return null
      const last = g[g.length - 1]
      return last === '' || last === null || last === undefined ? null : [last]
    }

    // 组装接口请求体。注意字段原样：starTime（少t）
    const buildQueryFun = () => {
      const q = {
        // 按天时 starTime/endTime 为 YYYY-MM-DD，按月时为 YYYY-MM（绑定月份选择器）
        starTime: timeRange.value.start,
        endTime: timeRange.value.end,
        userName: state.userName && state.userName.length > 0 ? state.userName : null,
        groupName: lastGroupFun(),
        // 素材报表传 materialId，账户报表传 accountId（素材报表也可传 accountId 过滤账户）
        accountId: state.accountId && state.accountId.length > 0 ? state.accountId.map((s) => String(s)) : null,
        materialId: state.reportSub === 'material' && state.materialIdList && state.materialIdList.length > 0
          ? state.materialIdList.map((s) => String(s))
          : null,
        materialName: state.reportSub === 'material' && state.materialNameList && state.materialNameList.length > 0
          ? state.materialNameList.map((s) => String(s))
          : null,
        // 分页同时带 currentPage + currenPage，后端返回是 currenPage（少个t），两种拼写都带上兼容
        currentPage: state.currentPage,
        currenPage: state.currentPage,
        size: state.pagesize,
        orderField: state.orderField || null,
        orderDir: state.orderDir || null,
      }
      if (state.quanyuType === 17 || state.quanyuType === 18) q.type = state.quanyuType
      return q
    }

    // 日期校验：按天最多相差31天
    const checkDateFun = () => {
      if (!state.date || !state.date[0] || !state.date[1]) {
        ElMessage.warning('请先选择开始 / 结束日期')
        return false
      }
      if (state.dateType === 'day' && daySpan.value > 31) {
        ElMessage.warning('按天查询日期跨度不能超过 31 天，请缩短区间或切换按月汇总')
        return false
      }
      return true
    }

    // 解析分页返回：data.currenPage / data.totalSize / data.data
    const unwrapPageFun = (resp) => {
      const page = resp?.data ?? resp ?? {}
      const list = page.data ?? page.list ?? page.records ?? []
      return {
        list: Array.isArray(list) ? list : [],
        total: page.totalSize ?? page.total ?? 0,
        page: page.currenPage ?? page.currentPage ?? state.currentPage,
      }
    }

    // 求和（null 按 0 处理）
    const sumFun = (rows, key) => rows.reduce((s, r) => s + (Number(r?.[key]) || 0), 0)

    // KPI汇总（本页合计）
    const refreshKpiFun = () => {
      const rows = state.tableData
      if (state.reportSub === 'material') {
        const show = sumFun(rows, 'showCnt')
        const click = sumFun(rows, 'clickCnt')
        const gmv = sumFun(rows, 'gmv')
        state.kpi = {
          ...state.kpi,
          show: String(Math.round(show * 100) / 100),
          click: String(Math.round(click * 100) / 100),
          amount: gmv.toFixed(2),
          gmv24h: sumFun(rows, 'billingGmv24h').toFixed(2),
          gmv0day: sumFun(rows, 'billingGmv0day').toFixed(2),
          gmv3days: sumFun(rows, 'billingGmv3days').toFixed(2),
          microAmount: sumFun(rows, 'microGameAmount').toFixed(2),
          payAmount: sumFun(rows, 'payAmountFen').toFixed(2),
          ctr: show ? ((click / show) * 100).toFixed(2) : '0.00',
          recovery: '0.00',
        }
        return
      }
      const cost = sumFun(rows, 'statCost')
      const gmv = sumFun(rows, 'gmv')
      const show = sumFun(rows, 'showCnt')
      const click = sumFun(rows, 'clickCnt')
      state.kpi = {
        ...state.kpi,
        cost: cost.toFixed(2),
        amount: gmv.toFixed(2),
        gmv24h: sumFun(rows, 'billingGmv24h').toFixed(2),
        gmv0day: sumFun(rows, 'billingGmv0day').toFixed(2),
        gmv3days: sumFun(rows, 'billingGmv3days').toFixed(2),
        gmv7days: sumFun(rows, 'billingGmv7days').toFixed(2),
        totalCost: sumFun(rows, 'statTotalCost').toFixed(2),
        fans: String(Math.round(sumFun(rows, 'dyFollow') * 100) / 100),
        show: String(Math.round(show * 100) / 100),
        click: String(Math.round(click * 100) / 100),
        ctr: show ? ((click / show) * 100).toFixed(2) : '0.00',
        recovery: cost ? ((gmv / cost) * 100).toFixed(2) : '0.00',
      }
    }

    // 主查询：按二级导航（账户/素材） + 按天/按月 选择接口，列表与汇总一起请求
    const reportListFun = async () => {
      // 升级版接口暂未提供，仅全域可查
      if (state.reportTab !== 'quanyu') return
      if (!checkDateFun()) return
      state.loading = true
      try {
        const datas = buildQueryFun()
        // 账户报表 / 素材报表，按天/按月选接口（表格 + 汇总）
        let resp
        if (state.reportSub === 'account') {
          // 账户报表
          if (state.dateType === 'day') {
            resp = await projectReportPageAccountByDay(datas)
            projectReporttotalAccountByDayFun() // 账户报表按天汇总
          } else {
            resp = await projectReportPageAccountByMonth(datas)
            projectReporttotalAccountByMonthFun() // 账户报表按月汇总
          }
        } else {
          // 素材报表
          if (state.dateType === 'day') {
            resp = await materialReportPageByDay(datas)
            materialReporttotalByDayFun() // 素材报表按天汇总
          } else {
            resp = await materialReportPageByMonth(datas)
            materialReporttotalByMonthFun() // 素材报表按月汇总
          }
        }
        const { list, total, page } = unwrapPageFun(resp)
        state.tableData = list
        state.total = Number(total) || 0
        state.currentPage = Number(page) || state.currentPage
      } catch (e) {
        state.tableData = []
        state.total = 0
      } finally {
        state.loading = false
      }
    }

    // 一级导航切换（升级版接口暂未提供：点升级版只提示，不切换、不发请求）
    const switchLevel1Fun = (v) => {
      if (v !== 'quanyu') {
        state.showShengjiTip = true
        state.reportTab = 'quanyu'
        ElMessage.warning('升级版报表接口暂未提供，当前仅支持全域报表')
        return
      }
      state.reportTab = v
      state.reportSub = 'account'
      state.focusAccountId = ''
      state.currentPage = 1
      reportListFun()
    }
    // 二级导航切换：列表 + 汇总统一走 reportListFun
    const switchSubFun = (v) => {
      if (state.shujuyuan == 'shujuyuan') {
        return
      }
      if (v) state.reportSub = v
      state.currentPage = 1
      reportListFun()
    }
    // 统计口径切换：回填月份区间后，列表 + 汇总统一走 reportListFun
    const dateTypeChangeFun = (v) => {
      if (v) state.dateType = v
      state.currentPage = 1
      if (state.dateType === 'month' && (!state.monthRange || !state.monthRange[0])) {
        state.monthRange = [todayMonthStr(), todayMonthStr()]
      }
      reportListFun()
    }
    // 月份切换：列表 + 汇总统一走 reportListFun
    const monthChangeFun = () => {
      state.currentPage = 1
      reportListFun()
    }
    // 日期切换：按天时刷新筛选下拉，列表 + 汇总统一走 reportListFun
    const dateChangeFun = () => {
      if (state.shujuyuan == 'shujuyuan') {
        return
      }
      state.currentPage = 1
      if (state.dateType === 'day') {
        filterOptionsFun()
      }
      reportListFun()
    }
    // 搜索：列表 + 汇总统一走 reportListFun
    const searchFun = () => {
      if (state.shujuyuan == 'shujuyuan') {
        return
      }
      state.currentPage = 1
      state.keyword = (state.accountName || '').trim()
      reportListFun()
    }
    // 关键字回车（仅本页过滤，不翻页不请求）
    const keywordEnterFun = () => {
      state.keyword = (state.accountName || '').trim()
    }
    // 重置
    const resetFun = () => {
      state.userName = []
      state.textstring = ''
      state.materialIdtextstring = ''
      state.materialNametextstring = ''

      state.accountId = []
      state.materialIdList = []
      state.materialNameList = []
      state.groupName = []
      state.accountName = ''
      state.keyword = ''
      state.quanyuType = 18
      state.focusAccountId = ''
      state.date = [todayStr(), todayStr()]
      state.dateType = 'day'
      state.currentPage = 1
      reportListFun()
    }
    // 账户ID输入框解析（支持换行/逗号/空格/分号分隔）
    const accountInputChangeFun = () => {
      state.accountId = String(state.textstring || '')
        .split(/[\n,，;；\s]+/)
        .map((s) => s.trim())
        .filter((s) => s !== '')
    }
    // 素材ID输入框解析（支持换行/逗号/空格/分号分隔）
    const materialIdInputChangeFun = () => {
      state.materialIdList = String(state.materialIdtextstring || '')
        .split(/[\n,，;；\s]+/)
        .map((s) => s.trim())
        .filter((s) => s !== '')
    }
    // 素材名称输入框解析（支持换行/逗号/空格/分号分隔）
    const materialNameInputChangeFun = () => {
      state.materialNameList = String(state.materialNametextstring || '')
        .split(/[\n;；\s]+/)
        .map((s) => s.trim())
        .filter((s) => s !== '')
    }

    // 清空账户ID
    const clearAccountIdFun = () => {
      state.textstring = ''
      state.accountId = []
    }
    // 清空素材ID
    const clearmaterialIdFun = () => {
      state.materialIdtextstring = ''
      state.materialIdList = []
    }
    // 清空素材ID
    const clearmateriaNameFun = () => {
      state.materialNametextstring = ''
      state.materialNameList = []
    }

    // 查看项目：打开弹窗，按选中账户查项目报表
    const gotoProjectFun = (row) => {
      if (!row?.advertiserId) return ElMessage.warning('该行缺少账户ID')
      state.focusAccountId = String(row.advertiserId)
      state.projectCurrentPage = 1
      state.projectView = true
      projectReportPageProjectFun()
    }
    // 项目弹窗查询：按天/按月选接口，accountId 传弹窗选中的账户
    const projectReportPageProjectFun = () => {
      if (!checkDateFun()) return
      state.projectLoading = true
      const datas = {
        type: state.quanyuType,
        starTime: state.date[0],
        endTime: state.date[1],
        userName: state.userName && state.userName.length > 0 ? state.userName : null,
        groupName: lastGroupFun(),
        accountId: state.focusAccountId ? [String(state.focusAccountId)] : null,
        currentPage: state.projectCurrentPage,
        size: state.projectPagesize
      }
      const req = state.dateType === 'day'
        ? projectReportPageProjectByDay(datas)
        : projectReportPageProjectByMonth(datas)
      req.then((res) => {
        state.projectTable = res.data.data
        state.projectCurrentPage = res.data.currenPage
        state.projectTotal = res.data.totalSize
      }).catch(() => {
        state.projectTable = []
        state.projectTotal = 0
      }).finally(() => {
        state.projectLoading = false
      })
    }
    // 筛选下拉（投放人/部门）
    const filterOptionsFun = () => {
      if (state.shujuyuan == 'shujuyuan') {
        return
      }
      getRequestList({ starTime: state.date?.[0], endTime: state.date?.[1], type: state.quanyuType })
        .then((res) => {
          state.getRequestLists = res.data || { userName: [], groupName: [] }
        })
        .catch(() => { })
    }
    // 导出：账户 /r3/projectReport/export，素材 /r3/materialReport/export（POST，baseURL 自动切换环境）
    const exportFun = async () => {
      if (!checkDateFun()) return
      state.exportLoading = true
      try {
        const isMaterial = state.reportSub === 'material'
        const data = {
          type: state.quanyuType,
          starTime: timeRange.value.start,
          endTime: timeRange.value.end,
          userName: state.userName && state.userName.length > 0 ? state.userName : null,
          groupName: lastGroupFun(),
          accountId: state.accountId && state.accountId.length > 0 ? state.accountId.map((s) => String(s)) : [],
          orderField: state.orderField || null,
          orderDir: state.orderDir || null,
        }
        if (isMaterial) {
          data.materialId = state.materialIdList && state.materialIdList.length > 0
            ? state.materialIdList.map((s) => String(s))
            : null
          data.materialName = state.materialNameList && state.materialNameList.length > 0
            ? state.materialNameList.map((s) => String(s))
            : null
        }
          const resp = await fetch(`${baseURL}${isMaterial ? '/r3/materialReport/export' : '/r3/projectReport/export'}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json;charset=UTF-8',
              authorize: 'Bearer' + localStorage.getItem('token'),
            },
            body: JSON.stringify(data),
          })
          if (!resp.ok) throw new Error(`导出失败(${resp.status})`)
          const blob = await resp.blob()
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = `${isMaterial ? '素材报表' : '账户报表'}_${data.starTime}_${data.endTime}.xlsx`
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
          ElMessage.success('导出成功')
        } catch (e) {
          ElMessage.error(e?.message || '导出失败')
        } finally {
          state.exportLoading = false
        }
    }
    // 素材补数
    const syncFun = async () => {
      if (!checkDateFun()) return
      try {
        const datas = buildQueryFun()
        await materialReportSync({ starTime: datas.starTime, endTime: datas.endTime, type: datas.type })
        ElMessage.success('补数请求已提交，请稍后重新搜索')
      } catch (e) {
        // https.js 已全局提示
      }
    }

    // 账户报表按天，默认进来请求这个
    const projectReportPageAccountByDayFun = () => {
      if (state.shujuyuan == 'shujuyuan') {
        return
      }
      const datas = {
        type: state.quanyuType,
        // 按天 YYYY-MM-DD / 按月 YYYY-MM（绑定月份选择器）
        starTime: timeRange.value.start,
        endTime: timeRange.value.end,
        userName: state.userName || null,
        groupName: state.groupName != null ? (state.groupName.length > 0 ? [state.groupName[state.groupName.length - 1]] : []) : [],

        accountId: state.accountId || null,
        currentPage: state.currentPage,
        size: state.pagesize,
        orderField: state.orderField || null,
        orderDir: state.orderDir || null,
      }
      projectReportPageAccountByDay(datas).then((res) => {
        state.tableData = res.data.data
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
      })

    }

    // 账户报表汇总数据，默认进来请求这个（参数同 projectReportPageAccountByDayFun）
    const projectReporttotalAccountByDayFun = () => {
      if (state.shujuyuan == 'shujuyuan') {
        return
      }
      const datas = {
        type: state.quanyuType,
        // 按天 YYYY-MM-DD / 按月 YYYY-MM（绑定月份选择器）
        starTime: timeRange.value.start,
        endTime: timeRange.value.end,
        userName: state.userName || null,
        groupName: state.groupName != null ? (state.groupName.length > 0 ? [state.groupName[state.groupName.length - 1]] : []) : [],
        accountId: state.accountId || null,
        currentPage: state.currentPage,
        size: state.pagesize
      }
      projectReporttotalAccountByDay(datas).then((res) => {
        const row = Array.isArray(res.data) ? res.data[0] : (res.data && res.data.data ? res.data.data[0] : res.data)
        const d = row || {}
        const cost = Number(d.statCost) || 0
        const gmv = Number(d.gmv) || 0
        const show = Number(d.showCnt) || 0
        const click = Number(d.clickCnt) || 0
        state.kpi = {
          ...state.kpi,
          cost: formatMoney(d.statCost),
          amount: formatMoney(d.gmv),
          gmv24h: formatMoney(d.billingGmv24h),
          gmv0day: formatMoney(d.billingGmv0day),
          gmv3days: formatMoney(d.billingGmv3days),
          gmv7days: formatMoney(d.billingGmv7days),
          totalCost: formatMoney(d.statTotalCost),
          fans: formatNum(d.dyFollow),
          show: formatNum(d.showCnt),
          click: formatNum(d.clickCnt),
          ctr: show ? ((click / show) * 100).toFixed(2) : '0.00',
          recovery: cost ? ((gmv / cost) * 100).toFixed(2) : '0.00',
        }
      })

    }

    // 账户报表按月：列表赋值给账户报表表格（参数同 projectReportPageAccountByDayFun）
    const projectReportPageAccountByMonthFun = () => {
      const datas = {
        type: state.quanyuType,
        // 按月取选中月份的首日/末日 YYYY-MM-DD
        starTime: timeRange.value.start,
        endTime: timeRange.value.end,
        userName: state.userName || null,
        groupName: state.groupName != null ? (state.groupName.length > 0 ? [state.groupName[state.groupName.length - 1]] : []) : [],

        accountId: state.accountId || null,
        currentPage: state.currentPage,
        size: state.pagesize,
        orderField: state.orderField || null,
        orderDir: state.orderDir || null,
      }
      projectReportPageAccountByMonth(datas).then((res) => {
        state.tableData = res.data.data
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
      })

    }

    // 账户报表按月汇总：赋值给 KPI 汇总（参数同 projectReportPageAccountByDayFun）
    const projectReporttotalAccountByMonthFun = () => {
      const datas = {
        type: state.quanyuType,
        // 按月取选中月份的首日/末日 YYYY-MM-DD
        starTime: timeRange.value.start,
        endTime: timeRange.value.end,
        userName: state.userName || null,
        groupName: state.groupName != null ? (state.groupName.length > 0 ? [state.groupName[state.groupName.length - 1]] : []) : [],
        accountId: state.accountId || null,
        currentPage: state.currentPage,
        size: state.pagesize
      }
      projectReporttotalAccountByMonth(datas).then((res) => {
        const row = Array.isArray(res.data) ? res.data[0] : (res.data && res.data.data ? res.data.data[0] : res.data)
        const d = row || {}
        const cost = Number(d.statCost) || 0
        const gmv = Number(d.gmv) || 0
        const show = Number(d.showCnt) || 0
        const click = Number(d.clickCnt) || 0
        state.kpi = {
          ...state.kpi,
          cost: formatMoney(d.statCost),
          amount: formatMoney(d.gmv),
          gmv24h: formatMoney(d.billingGmv24h),
          gmv0day: formatMoney(d.billingGmv0day),
          gmv3days: formatMoney(d.billingGmv3days),
          gmv7days: formatMoney(d.billingGmv7days),
          totalCost: formatMoney(d.statTotalCost),
          fans: formatNum(d.dyFollow),
          show: formatNum(d.showCnt),
          click: formatNum(d.clickCnt),
          ctr: show ? ((click / show) * 100).toFixed(2) : '0.00',
          recovery: cost ? ((gmv / cost) * 100).toFixed(2) : '0.00',
        }
      })

    }

    // 素材报表汇总数据：按天 + 素材报表时搜索/换日期请求（参数：type/starTime/endTime/userName/materialId/accountId）
    const materialReporttotalByDayFun = () => {
      const datas = {
        type: state.quanyuType,
        // 按天 YYYY-MM-DD / 按月 YYYY-MM（绑定月份选择器）
        starTime: timeRange.value.start,
        endTime: timeRange.value.end,
        userName: state.userName || null,
        materialId: state.materialIdList || null,
        materialName: state.materialNameList || null,
        accountId: state.accountId || null
      }
      materialReporttotalByDay(datas).then((res) => {
        const row = Array.isArray(res.data) ? res.data[0] : (res.data && res.data.data ? res.data.data[0] : res.data)
        const d = row || {}
        const show = Number(d.showCnt) || 0
        const click = Number(d.clickCnt) || 0
        state.kpi = {
          ...state.kpi,
          show: formatNum(d.showCnt),
          click: formatNum(d.clickCnt),
          amount: formatMoney(d.gmv),
          gmv24h: formatMoney(d.billingGmv24h),
          gmv0day: formatMoney(d.billingGmv0day),
          gmv3days: formatMoney(d.billingGmv3days),
          microAmount: formatMoney(d.microGameAmount),
          payAmount: formatMoney(d.payAmountFen),
          ctr: show ? ((click / show) * 100).toFixed(2) : '0.00',
        }
      })

    }

    // 素材报表按月汇总：按月 + 素材报表时统计口径切换/月份切换请求（参数同 materialReporttotalByDayFun）
    const materialReporttotalByMonthFun = () => {
      const datas = {
        type: state.quanyuType,
        // 按月取选中月份的首日/末日 YYYY-MM-DD
        starTime: timeRange.value.start,
        endTime: timeRange.value.end,
        userName: state.userName || null,
        materialId: state.materialIdList || null,
        materialName: state.materialNameList || null,
        accountId: state.accountId || null
      }
      materialReporttotalByMonth(datas).then((res) => {
        const row = Array.isArray(res.data) ? res.data[0] : (res.data && res.data.data ? res.data.data[0] : res.data)
        const d = row || {}
        const show = Number(d.showCnt) || 0
        const click = Number(d.clickCnt) || 0
        state.kpi = {
          ...state.kpi,
          show: formatNum(d.showCnt),
          click: formatNum(d.clickCnt),
          amount: formatMoney(d.gmv),
          gmv24h: formatMoney(d.billingGmv24h),
          gmv0day: formatMoney(d.billingGmv0day),
          gmv3days: formatMoney(d.billingGmv3days),
          microAmount: formatMoney(d.microGameAmount),
          payAmount: formatMoney(d.payAmountFen),
          ctr: show ? ((click / show) * 100).toFixed(2) : '0.00',
        }
      })

    }

    projectReportPageAccountByDayFun()
    projectReporttotalAccountByDayFun()






    filterOptionsFun()
    // reportListFun()

    return {
      ...toRefs(state),
      projectReportPageAccountByDayFun,
      projectReportPageAccountByMonthFun,
      projectReporttotalAccountByDayFun,
      projectReporttotalAccountByMonthFun,
      materialReporttotalByDayFun,
      projectReportPageProjectFun,
      daySpan,
      monthLabel,
      recoveryBar,
      viewData,
      formatMoney,
      formatNum,
      formatCtr,
      reportListFun,
      switchLevel1Fun,
      switchSubFun,
      dateTypeChangeFun,
      dateChangeFun,
      monthChangeFun,
      searchFun,
      keywordEnterFun,
      resetFun,
      accountInputChangeFun,
      materialIdInputChangeFun,
      materialNameInputChangeFun,
      clearAccountIdFun,
      clearmaterialIdFun,
      clearmateriaNameFun,
      gotoProjectFun,
      filterOptionsFun,
      exportFun,
      syncFun,
    }
  },

  methods: {},
}
</script>

<style lang="scss" scoped>
.r3-page.paddbox {
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
  /* 自带滚动，不依赖全局 .paddbox 的媒体查询（1281~1439 之间全局没有给高度，会被 .home overflow:hidden 裁掉） */
  height: calc(100vh - 78px);
  min-height: 400px;
  margin-top: 0;
  padding: 12px 20px 28px;
  overflow-y: auto;
  overflow-x: hidden;
}

.r3-page>* {
  flex-shrink: 0;
}

.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  background: linear-gradient(135deg, #1d4ed8 0%, #409eff 60%, #67c23a 130%);
  border-radius: 10px;
  padding: 16px 18px;
  color: #fff;
}

.head-title {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
}

.head-sub {
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.9;
}

.page-head :deep(.el-input__wrapper),
.page-head :deep(.el-range-editor) {
  background: #fff;
}

.level1-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 900px) {
  .level1-row {
    grid-template-columns: 1fr;
  }
}

.level1-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 2px solid #ebeef5;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.level1-card:hover {
  border-color: #a0cfff;
}

.level1-card.active {
  border-color: #409eff;
  box-shadow: 0 4px 16px rgba(64, 158, 255, 0.18);
  background: linear-gradient(180deg, #f6faff 0%, #fff 70%);
}

.l1-icon {
  width: 42px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
}

.l1-icon.quanyu {
  background: linear-gradient(135deg, #409eff, #1d4ed8);
}

.l1-icon.shengji {
  background: linear-gradient(135deg, #67c23a, #009688);
}

.l1-name {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}

.l1-desc {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
}

.l1-check {
  margin-left: auto;
  font-size: 12px;
  color: #409eff;
  white-space: nowrap;
}

.level1-card.disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

.level1-card.disabled .l1-icon.shengji {
  background: linear-gradient(135deg, #a8abb2, #787b82);
}

.l1-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 10px;
  background: #fef0f0;
  color: #f56c6c;
  font-size: 11px;
  font-weight: 400;
  vertical-align: 1px;
}

.empty-card {
  margin-top: 4px;
}

.filter-card :deep(.el-card__body) {
  padding: 14px 16px;
}

.filter-row {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  flex-wrap: wrap;
}

.filter-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-label {
  font-size: 12px;
  color: #909399;
}

.filter-btns {
  display: flex;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
}

.filter-hint {
  margin-top: 10px;
  font-size: 12px;
  color: #606266;
  background: #f5f7fa;
  border-radius: 6px;
  padding: 6px 10px;
}

.filter-hint.warn {
  background: #fef0f0;
  color: #f56c6c;
}

.clear-link {
  color: #409eff;
  cursor: pointer;
  margin-left: 8px;
}

.kpi-row {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 1200px) {
  .kpi-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.kpi-card {
  border-radius: 10px;
  padding: 14px 16px;
  color: #fff;
  position: relative;
  overflow: hidden;
}

.kpi-card::after {
  content: '';
  position: absolute;
  right: -30px;
  top: -30px;
  width: 160px;
  height: 110px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
}

.kpi-card.cost {
  background: linear-gradient(135deg, #409eff, #1d4ed8);
}

.kpi-card.amount {
  background: linear-gradient(135deg, #67c23a, #009688);
}

.kpi-card.profit {
  background: linear-gradient(135deg, #e6a23c, #f56c6c);
}

.kpi-card.fans {
  background: linear-gradient(135deg, #722ed1, #409eff);
}

.kpi-card.recovery {
  background: linear-gradient(135deg, #303133, #606266);
}

.kpi-label {
  font-size: 12px;
  opacity: 0.9;
}

.kpi-value {
  margin-top: 6px;
  font-size: 24px;
  font-weight: 800;
}

.kpi-foot {
  margin-top: 6px;
  font-size: 12px;
  opacity: 0.9;
}

.nav-card :deep(.el-card__body) {
  padding: 12px 16px;
}

.nav-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.breadcrumb-mini {
  font-size: 13px;
  color: #909399;
}

.sub-nav-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.sub-pill {
  padding: 6px 16px;
  border-radius: 16px;
  border: 1px solid #dcdfe6;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  background: #fff;
}

.sub-pill.active {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}

.pill-tip {
  font-size: 12px;
  opacity: 0.9;
}

.sub-desc {
  font-size: 12px;
  color: #909399;
}

.table-card :deep(.el-card__body) {
  padding: 14px 16px;
}

/* 表格横向滚动交给 el-table 自身（列宽总和超出容器时它自己会出滚动条）。
   这里不要再加 overflow-x / min-width，否则外层和内层各出一条，会出现两条横向滚动条 */
.table-scroll {
  width: 100%;
  overflow: hidden;
}

.table-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 700;
  color: #303133;
  flex-wrap: wrap;
}

.table-title .count {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}

.title-tip {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}

.pagination {
  margin-top: 14px;
  display: flex;
  justify-content: center;
  text-align: center;
}
</style>
